import { useEffect } from 'react';
import { Outlet } from 'react-router';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import MobileNav from './MobileNav';
import ImpersonationBanner from './ImpersonationBanner';
import { OrderNotificationsProvider } from '@/contexts/OrderNotificationsContext';

export default function AppLayout() {
  useEffect(() => {
    const stored = localStorage.getItem('ghq-theme') || 'dark';
    if (stored === 'system') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      document.documentElement.classList.toggle('dark', prefersDark);
    } else {
      document.documentElement.classList.toggle('dark', stored === 'dark');
    }
  }, []);

  return (
    /* WebSocket-only "new orders" badge for the Orders tab — no REST, no
       per-page order fetch. Replaced the sidebar order-count badges. */
    <OrderNotificationsProvider>
      <div className="flex h-screen flex-col overflow-hidden bg-surface-subtle transition-colors duration-300">
        <ImpersonationBanner />
        <div className="flex flex-1 min-h-0">
          <Sidebar />
          <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
            <Topbar />
            <main className="flex-1 overflow-y-auto scrollbar-premium pt-4 px-3 lg:px-4 pb-24 lg:pb-8">
              <Outlet />
            </main>
          </div>
          <MobileNav />
        </div>
      </div>
    </OrderNotificationsProvider>
  );
}
